(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-with-slider"] && !window.DesignMode) return;
  try {
    
    var sliders = document.querySelectorAll('.dawn-image-slider #carousel');
  var flktyArray = [];

  sliders.forEach(function (slider) {
    var flkty = new Flickity(slider, {
      contain: true,
      imagesLoaded: true,
      fullscreen: true,
      lazyLoad: 3,
      pageDots: true,
      prevNextButtons: false,
    });

    flktyArray.push(flkty);
  });

  var prevButtons = document.querySelectorAll('.carousel-button-prev');
  var nextButtons = document.querySelectorAll('.carousel-button-next');

  prevButtons.forEach(function (prevButton) {
    var flkty = getFlktyInstance(prevButton);
    flkty.on('change', function (index) {
      if (index === 0) {
        prevButton.disabled = true;
      } else {
        prevButton.disabled = false;
      }
    });
    prevButton.addEventListener('click', function () {
      var flkty = getFlktyInstance(this);
      flkty.previous();
    });
  });

  nextButtons.forEach(function (nextButton) {
    var flkty = getFlktyInstance(nextButton);
    flkty.on('change', function (index) {
      if (index === flkty.cells.length - 1) {
        nextButton.disabled = true;
      } else {
        nextButton.disabled = false;
      }
    });
    nextButton.addEventListener('click', function () {
      var flkty = getFlktyInstance(this);
      flkty.next();
    });
  });

  function getFlktyInstance(element) {
    var slider = element.closest('.dawn-image-slider');
    var index = Array.from(document.querySelectorAll('.dawn-image-slider')).indexOf(slider);
    return flktyArray[index];
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warehouse-locations"] && !window.DesignMode) return;
  try {
    
  $(document).on('click', '.address-without-map li a[href^="#"]', function(e) {
    // target element id
    var id = $(this).attr('href');
    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }
    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();
    // top position relative to the document
    var pos = $id.offset().top - 16;
    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
});

  } catch(e) { console.error(e); }
})();
      })();
